class ProductStitcher extends HTMLElement {
  connectedCallback() {
    this._abort = new AbortController();
    this._label = this.querySelector('[js-stitcher-label]');
    this._defaultLabel = this._label ? this._label.textContent : '';

    this.addEventListener('click', this._onClick.bind(this), { signal: this._abort.signal });
    this.addEventListener('mouseover', this._onHover.bind(this), { signal: this._abort.signal });
    this.addEventListener('mouseleave', this._onLeave.bind(this), { signal: this._abort.signal });
  }

  disconnectedCallback() {
    this._abort.abort();
  }

  _onHover(e) {
    const item = e.target.closest('[js-stitcher-item]');
    if (!item || !this._label) return;
    this._label.textContent = item.dataset.title;
  }

  _onLeave() {
    if (this._label) this._label.textContent = this._defaultLabel;
  }

  async _onClick(e) {
    const item = e.target.closest('[js-stitcher-item]');
    console.log(item)
    if (!item) return;
    e.preventDefault();
    if (item.classList.contains('is-active')) return;

    const handle = item.dataset.handle;
    const sectionId = this.dataset.sectionId || 'main';
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = `${root}products/${handle}`;

    this.classList.add('is-loading');
    try {
      const res = await fetch(`${url}?section_id=${sectionId}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');
      const incoming = html.querySelector('[js-main-product]');
      const current = document.querySelector('[js-main-product]');
      if (!incoming || !current) throw new Error('Missing [js-main-product] wrapper');

      current.replaceWith(incoming);
      history.pushState({}, '', url);
      document.title = item.dataset.title;
      window.dispatchEvent(new CustomEvent('product-stitcher:swapped', { detail: { handle } }));
      document.dispatchEvent(new CustomEvent('pdp-widgets:init'));
    } catch (err) {
      console.error('[product-stitcher] swap failed', err);
      window.location.href = url;
    } finally {
      this.classList.remove('is-loading');
    }
  }
}

if (!customElements.get('product-stitcher')) {
  customElements.define('product-stitcher', ProductStitcher);
}
